import React, { useState } from "react";
import { IconButton, Popover, Typography, Box } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export default function InfoPopover({ title, message }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <InfoIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box sx={{ p: 2, maxWidth: 250 }}>
          <Typography fontWeight="bold">{title}</Typography>
          <Typography variant="body2">{message}</Typography>
        </Box>
      </Popover>
    </>
  );
}
